import React from "react";
import {ConnectedReduxProps} from "@reducers/index";
import StatisticsReport from "@components/discountCodes/item/StatisticsReport";
import UsesReport from "@components/discountCodes/item/UsesReport";
import {Tabs} from "antd";
import __i18n from "../../intl/__i18n";
const {TabPane} = Tabs;



interface PropsFromState {
  loading: boolean;
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;


const DiscountCodeReportPage = (props: AllProps) => {
  const {id} = props.match.params;
  
  return(
    <Tabs type="card">
      <TabPane tab={__i18n("Statistic Information")} key="statistic_information">
        <StatisticsReport filter={{ id : id }}/>
      </TabPane>
    
      <TabPane tab={__i18n("Usage Report")} key="usage_report">
        <UsesReport filter={{ id : id }}/>
      </TabPane>
    </Tabs>
  )
};


export default DiscountCodeReportPage




